module.exports = __webpack_public_path__ + "static/media/stove-kit.5108e9bd.svg";